/* ==========================================================================
   sl-offre-detecteur.js — silamp.fr
   Bloc fiche produit « 1 luminaire acheté = 1 détecteur à -50 % »
   Même bloc sur fiche luminaire (propose des détecteurs) et sur fiche
   détecteur (propose des luminaires) :
   - ouverture / fermeture du bloc au clic sur l'en-tête
   - sélecteur de pose intérieure / extérieure
   - carrousel : flèches, clavier, défilement tactile natif
   - ajout au panier du produit proposé, avec le produit de la fiche s'il
     n'y est pas déjà
   - fiche détecteur : prix à -50 % mis à jour selon la variante sélectionnée
   ========================================================================== */
(function () {
  'use strict';

  var TXT = { add: 'Ajouter', loading: 'Ajout…', done: 'Ajouté', retry: 'Réessayer' };

  function mainForm() {
    return document.querySelector('form[action*="/cart/add"]:not([data-sl-od-ignore])');
  }

  function mainVariant(root) {
    var form = mainForm();
    var input = form && form.querySelector('[name="id"]');
    return Number((input && input.value) || root.dataset.mainVariant);
  }

  function mainQty() {
    var form = mainForm();
    var input = form && form.querySelector('[name="quantity"]');
    return Math.max(1, parseInt(input && input.value, 10) || 1);
  }

  function setLabel(btn, text) {
    var t = btn.querySelector('.sl-od-add-txt');
    if (t) t.textContent = text;
  }

  function refreshCart(cart) {
    var detail = { cart: cart };
    ['cart:refresh', 'cart:updated', 'cart:change'].forEach(function (name) {
      document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail }));
      document.documentElement.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail }));
    });
    if (cart && typeof cart.item_count === 'number') {
      document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], [data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
      });
    }
  }


  /* ── Fiche détecteur : prix à -50 % selon la variante ──────────────────── */
  function setupDetectorPrice(root) {
    var data = root.querySelector('[data-sl-od-prix]');
    var elNew = root.querySelector('.sl-od-det-new');
    var elOld = root.querySelector('.sl-od-det-old');
    if (!data || !elNew || !elOld) return;

    var prices;
    try { prices = JSON.parse(data.textContent); } catch (e) { return; }
    var last = null;

    function sync() {
      var form = mainForm();
      var input = form && form.querySelector('[name="id"]');
      var id = input && String(input.value);
      if (!id || id === last || !prices[id]) return;
      last = id;
      elNew.innerHTML = prices[id][0];
      elOld.innerHTML = prices[id][1];
    }

    function later() {
      setTimeout(sync, 60);
      setTimeout(sync, 400);
    }

    document.addEventListener('change', later);
    document.addEventListener('variant:change', later);
    sync();
  }


  /* ── Carrousel ─────────────────────────────────────────────────────────── */
  function setupCarousel(list) {
    var track = list.querySelector('.sl-od-track');
    if (!track) return;
    var prev = list.querySelector('[data-sl-od-prev]');
    var next = list.querySelector('[data-sl-od-next]');
    var ticking = false;

    function step() {
      var card = track.querySelector('.sl-od-card');
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 12;
      var perView = Math.max(1, Math.floor((track.clientWidth + gap) / (card.offsetWidth + gap)));
      return perView * (card.offsetWidth + gap);
    }

    function update() {
      ticking = false;
      var max = track.scrollWidth - track.clientWidth;
      var card = track.querySelector('.sl-od-media');
      if (card) list.style.setProperty('--od-media-h', card.offsetHeight + 'px');
      list.classList.toggle('is-static', max <= 2);
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
    }

    function request() {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }

    track.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request);
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); track.scrollBy({ left: step(), behavior: 'smooth' }); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); track.scrollBy({ left: -step(), behavior: 'smooth' }); }
    });
    track.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', request, { once: true });
    });

    list._slOdUpdate = update;
    update();
  }


  function toggleOpen(root, btn) {
    var open = root.dataset.open !== 'true';
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    var txt = btn.querySelector('.sl-od-more-txt');
    root.dataset.open = open ? 'true' : 'false';
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (panel) {
      if (open) panel.removeAttribute('inert');
      else panel.setAttribute('inert', '');
    }
    if (txt) txt.textContent = open ? txt.dataset.txtOpen : txt.dataset.txtClosed;
    if (open) {
      root.querySelectorAll('[data-sl-od-list]:not([hidden])').forEach(function (list) {
        if (list._slOdUpdate) requestAnimationFrame(list._slOdUpdate);
      });
    }
  }

  function selectZone(root, zone) {
    if (root.dataset.zone === zone) return;
    root.dataset.zone = zone;
    root.querySelectorAll('[data-sl-od-zone]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-sl-od-zone') === zone ? 'true' : 'false');
    });
    root.querySelectorAll('[data-sl-od-list]').forEach(function (list) {
      var on = list.getAttribute('data-sl-od-list') === zone;
      list.hidden = !on;
      list.classList.remove('is-entering');
      if (on) {
        void list.offsetWidth;
        list.classList.add('is-entering');
        var track = list.querySelector('.sl-od-track');
        if (track) track.scrollLeft = 0;
        if (list._slOdUpdate) list._slOdUpdate();
      }
    });
  }

  function addToCart(root, btn) {
    var mainProduct = Number(root.dataset.mainProduct);
    var card = btn.closest('.sl-od-card');
    btn.classList.remove('is-error');
    btn.classList.add('is-loading');
    setLabel(btn, TXT.loading);

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var hasMain = (cart.items || []).some(function (i) { return i.product_id === mainProduct; });
        var items = [{ id: Number(btn.dataset.variant), quantity: 1 }];
        if (!hasMain) items.unshift({ id: mainVariant(root), quantity: mainQty() });
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        });
      })
      .then(function (r) {
        if (!r.ok) throw new Error('cart/add');
        return fetch('/cart.js', { headers: { Accept: 'application/json' } });
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        btn.classList.remove('is-loading');
        btn.classList.add('is-done');
        setLabel(btn, TXT.done);
        if (card) card.classList.add('is-added');
        var link = root.querySelector('.sl-od-cartlink');
        if (link) link.hidden = false;
        refreshCart(cart);
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-error');
        setLabel(btn, TXT.retry);
      });
  }

  function init() {
    document.querySelectorAll('[data-sl-od]').forEach(function (root) {
      if (root.dataset.slOdReady) return;
      root.dataset.slOdReady = '1';

      if (root.dataset.mode === 'detecteur') setupDetectorPrice(root);
      root.querySelectorAll('[data-sl-od-list]').forEach(setupCarousel);

      root.addEventListener('click', function (e) {
        var tg = e.target.closest('[data-sl-od-toggle]');
        if (tg) { toggleOpen(root, tg); return; }

        var seg = e.target.closest('[data-sl-od-zone]');
        if (seg) { selectZone(root, seg.getAttribute('data-sl-od-zone')); return; }

        var btn = e.target.closest('.sl-od-add');
        if (btn && !btn.classList.contains('is-loading') && !btn.classList.contains('is-done')) {
          addToCart(root, btn);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();